function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1 3.21777H3.9C3.4 3.21777 3 3.61777 3 4.11777V20.3178C3 20.7178 3.4 21.2178 3.9 21.2178H20.1C20.5 21.2178 21 20.7178 21 20.3178V4.11777C21 3.61777 20.5 3.21777 20.1 3.21777ZM9 7.21777H7V9.21777H9V7.21777ZM17 7.21777H11V9.21777H17V7.21777ZM17 11.2178H11V13.2178H17V11.2178ZM11 15.2178H17V17.2178H11V15.2178ZM7 11.2178H9V13.2178H7V11.2178ZM9 15.2178H7V17.2178H9V15.2178ZM5 19.2178H19V5.21777H5V19.2178Z",
  fill: "#E7E7E7"
});

function SvgRecall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecall);
export default __webpack_public_path__ + "static/media/Recall.376bd2c6.svg";
export { ForwardRef as ReactComponent };